module.exports = __webpack_public_path__ + "img/alternative_image.48656c15.jpg";